import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the post editor and categories a "Blog" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/content/blog')({
  staticData: { crumb: 'common:nav.blog' },
  component: Outlet,
});
